import styles from "./list.module.css";
import dayjs from "dayjs";
import { Card, Chip, Stack, Typography } from "@mui/material";
import { Calendar, MapPin, User } from "react-feather";
import ActionListItem from "./ActionListItem";
import StatusChip from "./StatusChip";
import { isLocalDelivery } from "../../../../utils/bookingStatus";
import { CurrencyPoundSharp } from "@mui/icons-material";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";
import LocalShippingOutlined from "@mui/icons-material/LocalShippingOutlined";


const BookingCard = ({ item, printBooking, setViewModalOpen, setViewDeliveryModalOpen, setViewId, setViewStr, setCancelModalOpen, setCancelId, setInvoiceMail, setInvoiceMailId, setSendInvoiceModalOpen }) => {

    return (<Card className={styles.BookingCard}>
        <div className={styles.BookingCardHeader}>
            <div>
                <Typography className={styles.BookingNo}>
                    #{item.booking_id}
                    <span className={item.freight_type === 'Air Freight' ? styles.FreightTagAir : styles.FreightTagSea}>
                        {isLocalDelivery(item) ? <LocalShippingOutlined /> : item.freight_type === 'Air Freight' ? <FlightTakeoffIcon /> : <DirectionsBoatIcon />}
                    </span>
                </Typography>
                <Typography className={styles.BookingDate}>{dayjs(item.created_at).format("DD MMM YYYY")}</Typography>
            </div>

            <ActionListItem
                item={item}
                printBooking={printBooking}
                setViewModalOpen={setViewModalOpen}
                setViewDeliveryModalOpen={setViewDeliveryModalOpen}
                setViewId={setViewId}
                setViewStr={setViewStr}
                setCancelModalOpen={setCancelModalOpen}
                setCancelId={setCancelId}
                setInvoiceMail={setInvoiceMail}
                setInvoiceMailId={setInvoiceMailId}
                setSendInvoiceModalOpen={setSendInvoiceModalOpen}
            />
        </div>

        <Stack spacing={2} mt={2}>
            <div className={styles.CardRow}>
                <User size={16} />
                <div>
                    <small>Customer</small>
                    <strong>{item.customer_name}</strong>
                </div>
            </div>

            <div className={styles.CardRow}>
                <MapPin size={16} />
                <div>
                    <small>{isLocalDelivery(item) ? "Delivery" : "Pickup"}</small>
                    <strong>{item.post_code}</strong>
                </div>
            </div>

            <div className={styles.CardRow}>
                <Calendar size={16} />
                <div>
                    <small>{isLocalDelivery(item) ? "Delivery Date" : "Pickup Date"}</small>
                    <strong>{dayjs(item.pickup_date).format("DD MMM YYYY")}</strong>
                </div>
            </div>

            <div className={styles.CardRow}>
                <CurrencyPoundSharp size={16} />
                <div>
                    <small>Total</small>
                    <strong>£{Number(item.total).toFixed(2)}</strong>
                </div>
            </div>

        </Stack>

        <div className={styles.BookingFooter}>
            <StatusChip status={item.status} localDelivery={isLocalDelivery(item)} />
            {item.payment_status === 1 ? <Chip label="Paid" color="success" /> : <Chip label="Unpaid" color="error" />}
        </div>

    </Card>);

};

export default BookingCard;